import React from 'react';
import Container from 'mf-react-ui/Container';
import { H1 } from 'mf-react-ui/Typography';
import './ErrorPage.scss';

type Props = {
  message: string;
};

const ErrorPage: React.FC<Props> = (props) => {
  const { message } = props;

  return (
    <div className="error-message">
      <Container>
        <H1 view="h2" align="center">
          {message}
        </H1>
      </Container>
    </div>
  );
};

export default ErrorPage;
